import {isEmpty, isFunction} from "lodash"
import {Component} from "react"

import {FormatMessage} from "../../types"
import isContentKey from "../isContentKey"

interface Props {
  formatMessage: FormatMessage
}

/**
 * A helper to resolve either a language key or an already translated string.
 * Useful for resolving defaultProps.
 *
 * 29.10.18: Defensive check added for component being a reference to the component OR the formatMessage function itself.
 * It seems much more obvious if you simply want to reference the formatMessage itself to do so rather than read it
 * from the props of a reference to a component.
 *
 */
export default (component: Component<Props> | FormatMessage, message: string, values = {}) => {
  let formatMessage = null
  if (isFunction(component)) {
    formatMessage = component
  } else if (component && "props" in component && !isEmpty(component.props)) {
    formatMessage = component.props.formatMessage
  } else {
    return message
  }

  if (formatMessage && isContentKey(message)) return formatMessage({id: message}, values)

  return message
}
